import { combineReducers } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import productReducer from './productSlice';
import stockItemReducer from './stockItemSlice';
import sizeReducer from './sizeSlice';
import userReducer from "./userSlice"
import wishlistReducer from "./wishlistSlice"
import searchReducer from "./wishlistSlice"
import adminReducer from './adminSlice';
import invoiceReducer from './invoiceSlice';
import groupItemReducer from './groupItemSlice';
import YearlyWorkScheduleReducer from './YearlyWorkScheduleSlice';
import orderReducer from './orderSlice';
import categoryReducer from './categorySlice';
import customerListReducer from "./customerListSlice";
import brandReducer from './brandSlice';
import facilityReducer from './facilitySlice';
import maintenanceReducer from './maintenanceSlice';

const rootReducer = combineReducers({
  cart: cartReducer,
  product: productReducer,
  stockItem: stockItemReducer,
  productSize: sizeReducer,
  user: userReducer,
  wishlist: wishlistReducer,
  admin: adminReducer,
  invoice: invoiceReducer,
  groupItems: groupItemReducer,
  YearlyWorkSchedule: YearlyWorkScheduleReducer,
  orders: orderReducer,
  category: categoryReducer,
  customerList: customerListReducer,
  brand: brandReducer,
  facility: facilityReducer,
  maintenance: maintenanceReducer
});

export default rootReducer;